import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function BanUser() {
  const location = useLocation();
  const [timeLeft, setTimeLeft] = useState('');
  const [reason, setReason] = useState('Violation of terms of service');
  const [banDate, setBanDate] = useState('');
  const [banExpiry, setBanExpiry] = useState('');

  useEffect(() => {
    // Parse ban details from location state or query params
    const searchParams = new URLSearchParams(location.search);
    const banReason = searchParams.get('reason') || 'Violation of terms of service';
    const expiryDate = searchParams.get('expiry') || '';
    
    setReason(banReason);
    
    if (expiryDate) {
      const expiry = new Date(expiryDate);
      setBanDate(expiry.toLocaleDateString());
      
      // Calculate time left
      const updateTimer = () => {
        const now = new Date();
        const diff = expiry - now;
        
        if (diff <= 0) {
          setTimeLeft('Ban has expired');
          clearInterval(timer);
          return;
        }
        
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        
        setTimeLeft(`${days}d ${hours}h ${minutes}m`);
      };
      
      updateTimer();
      const timer = setInterval(updateTimer, 60000);
      
      return () => clearInterval(timer);
    }
  }, [location]);

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white px-4 sm:px-6">
      {/* Blurred Gradient Background */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <div className="absolute -top-20 -left-20 w-[300px] h-[300px] sm:w-[400px] sm:h-[400px] md:w-[500px] md:h-[500px] bg-red-600 opacity-30 rounded-full blur-xl sm:blur-2xl md:blur-3xl animate-pulse"></div>
        <div className="absolute -bottom-20 -right-20 w-[200px] h-[200px] sm:w-[300px] sm:h-[300px] md:w-[400px] md:h-[400px] bg-rose-900 opacity-20 rounded-full blur-lg sm:blur-xl md:blur-2xl animate-pulse"></div>
      </div>
      
      <div className="relative z-10 bg-gray-900/90 p-6 sm:p-8 md:p-10 rounded-xl sm:rounded-2xl shadow-xl sm:shadow-2xl text-center border border-red-900/50 animate-fade-in-up w-full max-w-md mx-4">
        <div className="flex justify-center mb-4 sm:mb-6">
          <div className="p-3 bg-red-900/50 rounded-full">
            <svg className="h-12 w-12 sm:h-14 sm:w-14 text-red-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
            </svg>
          </div>
        </div>
        
        <h1 className="text-2xl sm:text-3xl font-extrabold mb-2 text-red-400">Account Restricted</h1>
        <p className="text-red-300 text-sm mb-6">Your account has been temporarily suspended</p>
        
        <div className="bg-gray-800/50 p-4 rounded-lg text-left mb-6">
          <div className="mb-3">
            <p className="text-gray-400 text-sm">Reason for restriction:</p>
            <p className="text-white font-medium">{reason}</p>
          </div>
          
          {banDate && (
            <div className="mb-3">
              <p className="text-gray-400 text-sm">Restriction applied on:</p>
              <p className="text-white font-medium">{banDate}</p>
            </div>
          )}
          
          {timeLeft && (
            <div>
              <p className="text-gray-400 text-sm">Time remaining:</p>
              <p className="text-yellow-400 font-medium">{timeLeft}</p>
            </div>
          )}
        </div>
        
        <div className="text-xs text-gray-500 mb-6">
          If you believe this is a mistake, please contact our support team with your account details.
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a 
            href="/" 
            className="px-6 py-3 rounded-lg bg-gray-700 hover:bg-gray-600 text-white font-medium text-sm transition-colors"
          >
            Return Home
          </a>
          <a 
            href="mailto:leoclubofsliit@gmail.com" 
            className="px-6 py-3 rounded-lg bg-red-600 hover:bg-red-500 text-white font-medium text-sm transition-colors"
          >
            Contact Support
          </a>
        </div>
      </div>
    </div>
  );
}

// Animation keyframes for fade-in-up
if (typeof document !== 'undefined' && !document.getElementById('ban-user-styles')) {
  const style = document.createElement('style');
  style.id = 'ban-user-styles';
  style.innerHTML = `
    .animate-fade-in-up {
      animation: fadeInUp 0.8s cubic-bezier(0.23, 1, 0.32, 1);
    }
    @keyframes fadeInUp {
      0% {
        opacity: 0;
        transform: translateY(40px);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `;
  document.head.appendChild(style);
}
